// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"841":"d3d1849236867fe05fe7","1333":"d3d1849236867fe05fe7","4741":"2eaf0f66dbe55071b9f4","5055":"d3d1849236867fe05fe7","9487":"d3d1849236867fe05fe7"}[chunkId] + ".css";
};